import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/ohms-law-calculator',
  component: () => import('../../routes/OhmsLawCalculator.svelte'),
  card: {
    id: 'ohms-law-calculator',
    title: "Ohm's Law",
    description: "Calculate voltage, current, resistance, and power using Ohm's Law. Enter any two values to find the other two.",
    icon: 'bolt',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-600',
    href: '/ohms-law-calculator',
    category: 'Physics & Science',
  },
  seo: {
    title: "Ohm's Law Calculator – Calculate Voltage, Current, Resistance & Power",
    description:
      "Free Ohm's Law calculator to find voltage, current, resistance, or power. Enter any two values to solve the circuit. Includes V=IR and P=VI formulas.",
  },
};

export default meta;
